import { createForm, createPrimitiveField, type ValidationError } from '@adv-frontend/form-kit';
import { createReaction } from '@adv-frontend/reactions';
import { getGeoCoderAddress } from '@/entities/geoCoder';
import { checkOrderDeliveryAvailable } from '@/entities/order';
import { type OrderDto } from '@/shared/api/order';

export type CourierAddressContext = {
    initialOrder: OrderDto;
    reinitializeOrderForm: (initialOrder: OrderDto, updatedOrder: OrderDto) => void;
    storeSlug: string;
};

export const COURIER_ADDRESS_FORM_ID = 'COURIER_ADDRESS_FORM_ID';

export const courierAddressForm = createForm({
    name: 'CourierAddressForm',
    fields: {
        fullAddress: createPrimitiveField({
            defaultValue: '',
            validators: (createValidators) => createValidators<ValidationError<'UNSUPPORTED_ADDRESS'>>(),
        }),
        floor: createPrimitiveField({
            defaultValue: '',
            validators: (createValidators) => createValidators<ValidationError<'REQUIRED_DELIVERY_FLOOR'>>(),
        }),
        appartment: createPrimitiveField({ defaultValue: '' }),
        entrance: createPrimitiveField({ defaultValue: '' }),
        intercom: createPrimitiveField({ defaultValue: '' }),
        comment: createPrimitiveField({ defaultValue: '' }),
    },
    context: (context: CourierAddressContext) => {
        return { form: context };
    },

    onSubmit: async ({ fullAddress, ...values }, formApi) => {
        try {
            const { locality, address } = await getGeoCoderAddress({ text: fullAddress });

            if (!address || !locality) {
                formApi.fields.fullAddress.addValidationError({ code: 'UNSUPPORTED_ADDRESS' });

                return;
            }

            const { is_available } = await checkOrderDeliveryAvailable({ address });

            if (!is_available) {
                formApi.fields.fullAddress.addValidationError({ code: 'UNSUPPORTED_ADDRESS' });

                return;
            }

            return { ...values, address, locality };
        } catch (e) {
            formApi.fields.fullAddress.addValidationError({ code: 'UNSUPPORTED_ADDRESS' });
        }

        return;
    },

    reactions: (createReactions) =>
        createReactions([
            // Изменение адреса доставки курьером внутри модалки выбоара адреса
            createReaction({
                *data(instance) {
                    return {
                        instance,
                        fullAddress: instance.fields.fullAddress.getValue(),
                    };
                },
                effect({ instance, fullAddress }, reactionApi) {
                    if (!reactionApi.prevData || fullAddress === reactionApi.prevData.fullAddress) {
                        return;
                    }

                    instance.fields.appartment.setValue('');
                    instance.fields.floor.setValue('');
                    instance.fields.entrance.setValue('');
                    instance.fields.intercom.setValue('');
                    instance.fields.comment.setValue('');
                },
            }),
        ]),
});
